import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ConsultDateUtil} from "../../../util/consultDateUtil";
import {FolhaESocialUtil} from "./FolhaESocialUtil";
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {FormControl, FormGroup} from "@angular/forms";
import {ConvertObjectPipe} from "../../../util/pipes/ConvertObjectPipe";
import {ContaBancariaDTO} from "../../../model/dto/ContaBancariaDTO";
import {takeUntil} from "rxjs/operators";
import {AccountPlanDTOResponse} from "../../../model/dto/AccountPlanDTOResponse";
import {HistoricDTOResponse} from "../../../model/dto/HistoricDTOResponse";
import {COMMA, ENTER} from "@angular/cdk/keycodes";
import {ReplaySubject, Subject} from "rxjs";
import {BankAccountProvider} from "../../../providers/company/bank_account/bank_account";
import {Snackbar} from "../../../util/snackbar";
import {AccountProvider} from "../../../providers/account/account";
import {LivroCaixa} from "../../../util/livroCaixa";
import {HistoricProvider} from "../../../providers/bookkeeping/historic/historic";
import {ReleaseType, ReleaseTypeString} from "../../../model/enum/ReleaseType";
import {
  CadastroContaBancariaComponent
} from "../minhasPropriedades/cadastro-conta-bancaria/cadastro-conta-bancaria.component";
import {
  CadastroPlanoDeContasComponent
} from "../cadastros/plano-de-contas/cadastro-plano-de-contas/cadastro-plano-de-contas.component";
import {CadastroHistoricoComponent} from "../cadastros/historicos/cadastro-historico/cadastro-historico.component";
import {PayrollProvider} from "../../../providers/bookkeeping/payroll/payroll";
import {PessoaFiscalDTO} from "../../../model/dto/PessoaFiscalDTO";
import {MemberProvider} from 'src/providers/company/member/member';
import {PropertyProvider} from "../../../providers/company/property/property";
import {ImovelDTO} from "../../../model/dto/ImovelDTO";
import {CadastroImovelComponent} from "../minhasPropriedades/cadastro-imovel/cadastro-imovel.component";
import {GrouperProvider} from "../../../providers/grouper/grouper";
import {GrouperDTOResponse} from "../../../model/dto/GrouperDTOResponse";
import {
  CadastroAgrupadoresComponent
} from "../cadastros/agrupadores/cadastro-agrupadores/cadastro-agrupadores.component";
import * as moment from "moment";
import {CheckPermission} from "../../../service/checkPermission";
import {CadastrarLancamentoComponent} from "../financeiro/cadastrar-lancamento/cadastrar-lancamento.component";
import {PostingProvider} from "../../../providers/bookkeeping/posting/posting";
import {UserProvider} from "../../../providers/user/user";
import {ParticipantProvider} from "../../../providers/participant/participant";
import {CertificadoProvider} from "../../../providers/certificado/certificadoProvider";
import Swal from "sweetalert2";

@Component({
  selector: 'app-folha-esocial',
  templateUrl: './folha-esocial.component.html',
  styleUrls: ['./folha-esocial.component.scss']
})
export class FolhaEsocialComponent implements OnInit, OnDestroy {
  protected _onDestroy = new Subject<void>();

  public members: PessoaFiscalDTO[] = [];
  public selectedMember = null;


  // THE POSTING STUFF FOR SELECTS, FILTERS AND SEARCHES
  public bankAccounts: ContaBancariaDTO[] = [];
  public bankAccountFilterCtrl: FormControl[] = [new FormControl(), new FormControl(), new FormControl()];
  public filter_bankAccount: ReplaySubject<ContaBancariaDTO[]>[] = [];
  public planAccounts: AccountPlanDTOResponse[] = [];
  public planAccountFilterCtrl: FormControl[] = [new FormControl(), new FormControl(), new FormControl()];
  public filter_planAccount: ReplaySubject<AccountPlanDTOResponse[]>[] = [];
  public historics: HistoricDTOResponse[] = [];
  public historicFilterCtrl: FormControl[] = [new FormControl(), new FormControl(), new FormControl()];
  public filter_historic: ReplaySubject<HistoricDTOResponse[]>[] = [];
  public properties: ImovelDTO[] = [];
  public propertyFilterCtrl: FormControl = new FormControl();
  public filter_property: ReplaySubject<ImovelDTO[]> = new ReplaySubject<ImovelDTO[]>(1);
  public groupers: GrouperDTOResponse[] = [];
  public grouperFilterCtrl = new FormControl();
  public filter_grouper: ReplaySubject<GrouperDTOResponse[]> = new ReplaySubject<GrouperDTOResponse[]>(1);
  public separatorKeysCodes: number[] = [ENTER, COMMA];
  public arrayReleaseType = ["0 - Sem movimentação fiscal", "1 - Receita da atividade rural", "2 - Despesa de custeio e investimentos", "3 - Receita de produtos entregues no ano referente a adiamento de recursos financeiros"];


  public loading: boolean = false;

  public automaticSearch: boolean = false;
  public automaticSearchData: [] = [];
  public automaticSearchChanged: boolean = false;

  // THE SAVED POSTING PARAMETERS FOR FUTURE POSTING
  public postingParameters: any = {
    edit: false,

    // OFFICE SAVED DATA, SENDS THE WHOLE OFFICE WHEN UPDATING COMPANY DATA
    officePostingData: {},

    // COMPANY POSTED DATA, ALL THE IDS AND STUFF, THIS WILL BE USED TO POST THE DATA
    postingData: {
      payroll: {},
      fgts: {},
      inss: {},
      general: {},
    },

    // POSTING ITEMS, THIS WILL BE USED TO SHOW USER THE DATA
    postingItems: {
      payroll: {},
      fgts: {},
      inss: {},
      general: {},
    },

    // POSTING FORMS, THIS WILL BE USED TO ALTER USER THE DATA
    postingForms: {
      payroll: FolhaESocialUtil.createPostingFormGroup(),
      fgts: FolhaESocialUtil.createPostingFormGroup(),
      inss: FolhaESocialUtil.createPostingFormGroup(),
      general: new FormGroup({
        property: new FormControl(null),
      }),
    },
  };

  public navigationTabs = {
    tabs: [
      'Funcionário',
      'FGTS',
      'INSS'
    ],
    activeTab: 'Funcionário',
  }

  @ViewChild('grouperInput', {static: false}) grouperInput: ElementRef<HTMLInputElement>;

  @ViewChild('grid', {static: false}) grid = null;
  public activeColumns = [];
  public subGrid = {
    dataSource: null,
    height: '100%',
    width: '90%',
    columns: null,
  };

  public data = {
    dataSourceMain: {},
    dataSourceTable: null,
    // PRESET TABS GRIDS ON GET
    grids: {
      payroll: null,
      inss: null,
      fgts: null,
    },
    indicators: {total: 0, payroll: 0, fgts: 0, inss: 0},
    existingPostingByField: {
      payroll: false,
      fgts: false,
      inss: false,
    }
  }

  constructor(
    public consultDateUtil: ConsultDateUtil,
    public modalService: NgbModal,
    public snackBar: Snackbar,
    public livroCaixa: LivroCaixa,
    public bankAccountProvider: BankAccountProvider,
    private accountProvider: AccountProvider,
    private historicProvider: HistoricProvider,
    public payrollProvider: PayrollProvider,
    public memberProvider: MemberProvider,
    public propertyProvider: PropertyProvider,
    private grouperProvider: GrouperProvider,
    public checkPermission: CheckPermission,
    public postingProvider: PostingProvider,
    public userProvider: UserProvider,
    public participantProvider: ParticipantProvider,
    public certificadoProvider: CertificadoProvider,
  ) {
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  async ngOnInit() {
    await this.getMemberData();
    this.getAutomaticSearchData();
    this.getPostingData();
    this.getPayrollData();
  }

  async getMemberData() {
    this.loading = true;
    try {
      const members: any = await this.memberProvider.getMembersByCompanyId(+localStorage.getItem('idEmpresa'));
      const membersParticipantsIds: any = await this.participantProvider.getParticipantByCpfCnpj(members.map((item) => item.cpfCNPJ));
      this.members = members.filter(item => item.certificateDTORespComp).map(({cpfCNPJ, name}) => ({
        participantId: membersParticipantsIds.find((item) => item.cpfCNPJParticipant === cpfCNPJ).id,
        cpf: cpfCNPJ,
        cpfFormatted: cpfCNPJ.length == 11 ? cpfCNPJ.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : cpfCNPJ.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5"),
        name,
      })).sort((a, b) => a.name.localeCompare(b.name));
      this.selectedMember = this.members[0] || null;
      this.loading = false;
    } catch (error) {
      this.snackBar.open(`${error.error.error_description}`, 'erro');
    } finally {
      this.loading = false;
    }
  }

  getAutomaticSearchData() {
    this.loading = true;
    this.certificadoProvider.getESConfig(localStorage.getItem('idEmpresa'))
      .then((result: []) => {
        const memberData = result.find(item => item[0] === this.selectedMember.cpf);
        this.automaticSearch = memberData ? memberData[1] : false;
        this.automaticSearchData = result;
      })
      .catch(error => this.snackBar.open(`${error.error.error_description}`, 'erro'))
      .finally(() => this.loading = false);
  }

  async getPayrollData() {

    if (!this.selectedMember) {
      return;
    }

    this.loading = true;

    this.data = {
      dataSourceMain: [],
      dataSourceTable: null,
      grids: {
        payroll: null,
        inss: null,
        fgts: null,
      },
      indicators: {total: 0, payroll: 0, fgts: 0, inss: 0},
      existingPostingByField: {
        payroll: false,
        fgts: false,
        inss: false,
      }
    };

    try {
      const period = {
        month: this.consultDateUtil.getMonth(this.consultDateUtil.month).toString().padStart(2, '0'),
        year: this.consultDateUtil.year.toString(),
      };

      const item = await this.payrollProvider.getByCompanyId(
        localStorage.getItem('idEmpresa'),
        this.selectedMember.cpf,
        period
      );

      this.data.dataSourceMain = FolhaESocialUtil.processData(item, this.selectedMember.cpf);
      this.presetGrids(this.data.dataSourceMain);
    } catch (error) {
      console.error('Failed to load members:', error);
    } finally {
      this.loading = false;
      this.changeTab();
    }
  }

  presetGrids(data) {
    this.data.grids = {
      payroll: {
        processData: this.processDataSourcePayroll(data.servers),
        columns: FolhaESocialUtil.columns.columnsFuncionarios,
        subgridColumns: FolhaESocialUtil.columns.columnsFuncionariosSubgrid,
        queryString: 'cpf',
      },
      fgts: {
        processData: this.processDataSourceFGTS(data.fgts),
        columns: FolhaESocialUtil.columns.columnsFGTS,
        subgridColumns: FolhaESocialUtil.columns.columnsFGTSSubgrid,
        queryString: 'query',
      },
      inss: {
        processData: this.processDataSourceInssIr(data.inss),
        columns: FolhaESocialUtil.columns.columnsINSS,
        subgridColumns: FolhaESocialUtil.columns.columnsINSSSubgrid,
        queryString: 'type',
      },
    }
    this.data.indicators.total = this.data.indicators.payroll + this.data.indicators.fgts + this.data.indicators.inss;
  }

  getTypePriority(type) {
    const types = {
      'Vencimento': 1,
      'Desconto': 2,
      'Informativa': 3
    };
    return types[type] || 4;
  }

  processDataSourcePayroll = (dataSource: any[]): [any[], any[]] => {
    const dataSourceFuncionarios = dataSource.map(({payments, ...rest}) => {
      const value = payments.reduce((acc, {value = 0, type}) => {
        const adjustedValue = Math.round(value * 100);
        return type === 'Vencimento' ? acc + adjustedValue : (type === 'Desconto' ? acc - adjustedValue : acc);
      }, 0) / 100;

      const postingId = payments.filter(payment => payment.type === 'Vencimento').find(payment => payment.postingId) ? payments.filter(payment => payment.type === 'Vencimento').find(payment => payment.postingId).postingId : null;
      this.data.existingPostingByField.payroll = postingId;

      return {
        ...rest,
        value: +value.toFixed(2),
        valueFormatted: this.formatNumber(value, 'currency'),
        postingId: postingId,
        ids: payments
          .filter(payment =>
            payment.type === 'Vencimento'
          )
          .map(payment => payment.id),
      };
    });
    const subgrid = dataSource
      .map(({payments, cpf}) => {
        return payments.map(payment => ({
          ...payment,
          cpf,
          id: payment.id,
          amountFormatted: this.formatNumber(payment.amount, 'number'),
          typeFormatted: this.formatPaymentType(payment.type),
          valueFormatted: this.formatValuePayroll(this.formatNumber(payment.value, 'currency'), payment.type),
          value: (payment.value || 0).toFixed(2),
          amount: (payment.amount || 0).toFixed(2),
          paid: !!payment.postingId,
        }));
      })
      .reduce((acc, val) => acc.concat(val), []);


    this.data.indicators.payroll = dataSourceFuncionarios.reduce((acc, {value}) => {
      const adjustedValue = Math.round(value * 100);
      return acc + adjustedValue;
    }, 0) / 100;

    return [dataSourceFuncionarios.sort((a, b) => a.name.localeCompare(b.name)), subgrid.sort((a, b) => {
      if (this.getTypePriority(a.type) !== this.getTypePriority(b.type)) {
        return this.getTypePriority(a.type) - this.getTypePriority(b.type);
      }
      return +a.code > +b.code;
    })];
  };

  processDataSourceFGTS = (dataSource: any[]): [any[], any[]] => {
    const subgrid: any[] = [];

    for (const item of dataSource) {
      for (const r of item.payments) {
        if (r.description.includes('FGTS')) {
          subgrid.push({
            id: r.id,
            type: r.type,
            typeFormatted: this.formatPaymentType(r.type),
            value: r.value.toFixed(2),
            baseCalcValue: r.baseCalcValue.toFixed(2),
            valueFormatted: this.formatNumber(r.value, 'currency'),
            baseCalcValueFormatted: this.formatNumber(r.baseCalcValue, 'currency'),
            description: r.description,
            code: r.code,
            paid: !!r.postingId,
            postingId: r.postingId,
            query: 'a',
          });
        }
      }
    }

    const totalFGTS = subgrid.reduce((acc, {value}) => {
      const adjustedValue = Math.round(value * 100);
      return acc + adjustedValue;
    }, 0) / 100;
    this.data.indicators.fgts = totalFGTS;

    const postingId = subgrid.find(item => item.paid) ? subgrid.find(item => item.paid).postingId : null;
    this.data.existingPostingByField.fgts = postingId;


    return [subgrid.length ? [{
      ids: subgrid.map(item => item.id),
      value: totalFGTS,
      postingId: postingId,
      valueFormatted: this.formatNumber(totalFGTS, 'currency'),
      description: 'FGTS',
      query: 'a'
    }] : [], subgrid.sort((a, b) => {
      return +a.code - +b.code;
    })];
  }

  processDataSourceInssIr = (dataSource: any[]): [any[], any[]] => {
    const subgrid: any[] = [];

    for (const item of dataSource) {
      for (const r of item.payments) {
        subgrid.push({
          id: r.id,
          type: r.type,
          value: r.value.toFixed(2),
          valueFormatted: this.formatNumber(r.value, 'currency'),
          description: r.description,
          code: r.code,
          paid: !!r.postingId,
          postingId: r.postingId,
          query: 'type',
        });
      }
    }

    this.data.indicators.inss = subgrid.reduce((acc, {value}) => {
      const adjustedValue = Math.round(value * 100);
      return acc + adjustedValue;
    }, 0) / 100;

    const calculateTotal = (type: string) =>
      subgrid
        .filter(item => item.type === type)
        .reduce((acc, {value}) => {
          const adjustedValue = Math.round(value * 100);
          return acc + adjustedValue;
        }, 0) / 100;

    const postingId = subgrid.filter(item => item.type === 'TB_INSS' || item.type === 'TB_IRPF').find(item => item.paid) ? subgrid.filter(item => item.type === 'TB_INSS' || item.type === 'TB_IRPF').find(item => item.paid).postingId : null;
    this.data.existingPostingByField.inss = postingId;


    return [
      subgrid.length
        ? [
          {
            type: 'TB_INSS',
            value: calculateTotal('TB_INSS'),
            valueFormatted: this.formatNumber(calculateTotal('TB_INSS'), 'currency'),
            description: 'INSS',
            query: 'type',
            postingId: postingId,
            ids: subgrid.filter(item => item.type === 'TB_INSS').map(item => item.id),
          },
          {
            type: 'TB_IRPF',
            value: calculateTotal('TB_IRPF'),
            valueFormatted: this.formatNumber(calculateTotal('TB_IRPF'), 'currency'),
            description: 'Imposto de Renda',
            query: 'type',
            postingId: postingId,
            ids: subgrid.filter(item => item.type === 'TB_IRPF').map(item => item.id),
          },
        ]
        : [],
      subgrid,
    ];
  };

  changePeriod() {
    this.getPayrollData();
    this.handleFetchedData('date', this.consultDateUtil.getMonth(this.consultDateUtil.month), new ConvertObjectPipe());
  }

  changeTab() {

    const {activeTab} = this.navigationTabs;

    const config = this.data.grids[
      {
        'Funcionário': 'payroll',
        'FGTS': 'fgts',
        'INSS': 'inss'
      }[activeTab]
      ];
    if (config) {
      this.activeColumns = [...config.columns];
      [this.data.dataSourceTable, this.subGrid.dataSource] = config.processData;

      this.grid.columns.forEach(column => {
        column.visible = this.activeColumns.includes(column.field) || column.field === 'checkbox';
      });

      Object.assign(this.subGrid, {
        columns: config.subgridColumns,
        queryString: config.queryString,
      });

      if (this.grid) this.grid.refresh();
    }
  }

  async changeMember(member) {
    this.selectedMember = member;
    const automaticSerachMemberData = this.automaticSearchData.find((item) => item[0] == this.selectedMember.cpf);
    automaticSerachMemberData ? this.automaticSearch = automaticSerachMemberData[1] : this.automaticSearch = false;
    this.getPostingData();
    this.getPayrollData();
  }

  formatPaymentType(type: string): string {
    const icons = {
      vencimento: `<i class="fas fa-money-bill colorido fa-fw" style="color: #228B22;"></i>`,
      desconto: `<i class="fas fa-money-bill colorido fa-fw" style="color: #DC3545FF;"></i>`,
      informativa: `<i class="fas fa-receipt colorido fa-fw" style="color: #3C78D8;"></i>`
    };
    const lowerType = type.toLowerCase();
    for (const key in icons) {
      if (lowerType.includes(key)) {
        return `${icons[key]} ${type}`;
      }
    }
    return type;
  }

  formatValuePayroll(value: string, type: string): string {
    const icons = {
      vencimento: `<i class="fas fa-plus colorido fa-fw" style="color: #228B22;"></i>`,
      desconto: `<i class="fas fa-minus colorido fa-fw" style="color: #DC3545FF;"></i>`,
      informativa: `<i class="fas fa-info colorido fa-fw" style="color: #3C78D8;"></i>`
    };
    const lowerType = type.toLowerCase();
    for (const key in icons) {
      if (lowerType.includes(key)) {
        return `${icons[key]} ${value}`;
      }
    }
    return value;
  }

  formatNumber(item: number | null, type: string): string {
    item = item ? item : 0;
    if (type === 'number') {
      return item.toString().replace(/,/g, '.').replace(/\./g, ',');
    }
    if (type === 'currency') {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(item);
    }
    return item.toString();
  }

  saveAutomaticSearchOption(allMembers: boolean, checked: boolean) {
    const arr = allMembers
      ? this.members.map(member => [member['cpf'], checked])
      : [[this.selectedMember.cpf, checked]];

    this.loading = true;
    this.certificadoProvider.postESConfig(localStorage.getItem('idEmpresa'), arr)
      .then(() => {
        this.snackBar.open('Configuração salva com sucesso', 'success');
        this.automaticSearchChanged = false;
        this.getAutomaticSearchData();
      })
      .catch(error => this.snackBar.open(`${error.error.error_description}`, 'erro'))
      .finally(() => this.loading = false);
  }

  // POSTING // BOOKKEEPING STUFF

  getPostingData() {
    for (let i = 0; i < 3; i++) {
      this.filter_bankAccount[i] = new ReplaySubject<ContaBancariaDTO[]>(1);
      this.filter_planAccount[i] = new ReplaySubject<AccountPlanDTOResponse[]>(1);
      this.filter_historic[i] = new ReplaySubject<HistoricDTOResponse[]>(1);
    }
    this.fetchAllData();
  }

  fetchAllData(type?: 'bankAccounts' | 'planAccounts' | 'releaseType' | 'historics' | 'properties' | 'groupers' | 'date' | 'postingConfig') {
    this.loading = true;
    const pipe = new ConvertObjectPipe();

    const fetchMap: { [key: string]: () => Promise<any> } = {
      bankAccounts: () => this.bankAccountProvider.getAllBanksAccounts(),
      planAccounts: () => this.accountProvider.getAllAccountsLeafs(),
      historics: () => this.historicProvider.getAllHistorics(),
      properties: () => this.propertyProvider.getAllProperty(),
      groupers: () => this.grouperProvider.getAllGroupers(),
      postingConfig: () => this.userProvider.getEsPostingConfig(),
      releaseType: () => Promise.resolve(ReleaseTypeString),
      date: () => Promise.resolve(this.consultDateUtil.getMonth(this.consultDateUtil.month)),
    };

    const fetchAndHandle = (key: string): Promise<void> => {
      return fetchMap[key]()
        .then(result => this.handleFetchedData(key as any, result, pipe))
        .catch(error => this.handleFetchError(error));
    };

    if (type) {
      fetchAndHandle(type)
        .finally(() => this.loading = false);
    } else {
      fetchAndHandle('postingConfig')
        .then(() => {
          return Promise.all([
            fetchMap['bankAccounts']().then(result => this.handleFetchedData('bankAccounts', result, pipe)),
            fetchMap['planAccounts']().then(result => this.handleFetchedData('planAccounts', result, pipe)),
            fetchMap['releaseType']().then(result => this.handleFetchedData('releaseType', result, pipe)),
            fetchMap['historics']().then(result => this.handleFetchedData('historics', result, pipe)),
            fetchMap['properties']().then(result => this.handleFetchedData('properties', result, pipe)),
            fetchMap['groupers']().then(result => this.handleFetchedData('groupers', result, pipe)),
            fetchMap['date']().then(result => this.handleFetchedData('date', result, pipe)),
          ]);
        })
        .catch(error => this.handleFetchError(error))
        .finally(() => this.loading = false);
    }
  }

  handleFetchError(error: any) {
    console.error(error);
    this.snackBar.open('Erro ao buscar dados', 'error');
    this.loading = false;
  }

  handleFetchedData(type: 'bankAccounts' | 'planAccounts' | 'releaseType' | 'historics' | 'properties' | 'groupers' | 'date' | 'postingConfig', data: any, pipe: ConvertObjectPipe) {
    const dataMapping = {
      bankAccounts: () => {
        this.bankAccounts = pipe.transform(data, 'contasBancarias');
        if (this.postingParameters.postingData.payroll && this.postingParameters.postingData.payroll.bankAccountId) {
          this.postingParameters.postingItems.payroll['bankAccount'] = this.bankAccounts.find((item) => item.id == this.postingParameters.postingData.payroll.bankAccountId) || null;
        }
        if (this.postingParameters.postingData.fgts && this.postingParameters.postingData.fgts.bankAccountId) {
          this.postingParameters.postingItems.fgts['bankAccount'] = this.bankAccounts.find((item) => item.id == this.postingParameters.postingData.fgts.bankAccountId) || null;
        }
        if (this.postingParameters.postingData.inss && this.postingParameters.postingData.inss.bankAccountId) {
          this.postingParameters.postingItems.inss['bankAccount'] = this.bankAccounts.find((item) => item.id == this.postingParameters.postingData.inss.bankAccountId) || null;
        }
        this.initializeSearch('bankAccounts');
      },

      planAccounts: () => {
        this.planAccounts = pipe.transform(data, 'categoria');
        if (this.postingParameters.postingData.payroll && this.postingParameters.postingData.payroll.planAccountId) {
          this.postingParameters.postingItems.payroll['planAccount'] = this.planAccounts.find((item) => item.id == this.postingParameters.postingData.payroll.planAccountId) || null;
        }
        if (this.postingParameters.postingData.fgts && this.postingParameters.postingData.fgts.planAccountId) {
          this.postingParameters.postingItems.fgts['planAccount'] = this.planAccounts.find((item) => item.id == this.postingParameters.postingData.fgts.planAccountId) || null;
        }
        if (this.postingParameters.postingData.inss && this.postingParameters.postingData.inss.planAccountId) {
          this.postingParameters.postingItems.inss['planAccount'] = this.planAccounts.find((item) => item.id == this.postingParameters.postingData.inss.planAccountId) || null;
        }
        this.initializeSearch('planAccounts');
      },

      releaseType: () => {
        if (this.postingParameters.postingData.payroll && this.postingParameters.postingData.payroll.releaseType) {
          this.postingParameters.postingItems.payroll.releaseType = this.postingParameters.postingData.payroll.releaseType;
        }
        if (this.postingParameters.postingData.fgts && this.postingParameters.postingData.fgts.releaseType) {
          this.postingParameters.postingItems.fgts.releaseType = this.postingParameters.postingData.fgts.releaseType;
        }
        if (this.postingParameters.postingData.inss && this.postingParameters.postingData.inss.releaseType) {
          this.postingParameters.postingItems.inss.releaseType = this.postingParameters.postingData.inss.releaseType;
        }
      },

      historics: () => {
        this.historics = [];
        this.historics = [{
          id: 69,
          code: "DEFAULT",
          model: " LANÇAMENTO #@PARTICIPANTE@# DF-e #@NUMERO-DOCUMENTO@#.",
          description: "HISTÓRICO PADRÃO FARMCONT"
        }, ...data];
        if (this.postingParameters.postingData.payroll && this.postingParameters.postingData.payroll.historicId) {
          this.postingParameters.postingItems.payroll['historic'] = this.historics.find((item) => item.id == this.postingParameters.postingData.payroll.historicId) || null;
        }
        if (this.postingParameters.postingData.fgts && this.postingParameters.postingData.fgts.historicId) {
          this.postingParameters.postingItems.fgts['historic'] = this.historics.find((item) => item.id == this.postingParameters.postingData.fgts.historicId) || null;
        }
        if (this.postingParameters.postingData.inss && this.postingParameters.postingData.inss.historicId) {
          this.postingParameters.postingItems.inss['historic'] = this.historics.find((item) => item.id == this.postingParameters.postingData.inss.historicId) || null;
        }
        this.initializeSearch('historics');
      },

      properties: () => {
        this.properties = pipe.transform(data, 'imoveis');
        if (this.postingParameters.postingData.general && this.postingParameters.postingData.general.propertyCode) {
          this.postingParameters.postingItems.general['property'] = this.properties.find((item) => item.propertyCode == this.postingParameters.postingData.general.propertyCode) || null;
        }
        this.initializeSearch('properties');
      },

      groupers: () => {
        this.groupers = data;
        if (this.postingParameters.postingData.general && this.postingParameters.postingData.general.groupersIds) {
          this.postingParameters.postingItems.general['groupers'] = this.groupers.filter((item) => this.postingParameters.postingData.general.groupersIds.includes(item.id)).map((item) => item.name).join(', ');
        }
        this.initializeSearch('groupers');
      },

      date: () => {
        const formatDate = (day: number, mod: number): string => {
          const date = new Date(this.consultDateUtil.year, this.consultDateUtil.getMonth(this.consultDateUtil.month) - 1 + mod, day);
          const paddedDay = date.getDate().toString().padStart(2, '0');
          const paddedMonth = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear().toString().slice(-2);
          return `${paddedDay}/${paddedMonth}/${year}`;
        };

        if (this.postingParameters.postingData.payroll && this.postingParameters.postingData.payroll.date) {
          const nextMonth = this.postingParameters.postingData.payroll.nextMonth;
          const mod = nextMonth != null ? (nextMonth ? 1 : 0) : 1;
          this.postingParameters.postingItems.payroll.date = formatDate(this.postingParameters.postingData.payroll.date, mod);
        }
        if (this.postingParameters.postingData.fgts && this.postingParameters.postingData.fgts.date) {
          const nextMonth = this.postingParameters.postingData.fgts.nextMonth;
          const mod = nextMonth != null ? (nextMonth ? 1 : 0) : 1;
          this.postingParameters.postingItems.fgts.date = formatDate(this.postingParameters.postingData.fgts.date, mod);
        }
        if (this.postingParameters.postingData.inss && this.postingParameters.postingData.inss.date) {
          const nextMonth = this.postingParameters.postingData.inss.nextMonth;
          const mod = nextMonth != null ? (nextMonth ? 1 : 0) : 1;
          this.postingParameters.postingItems.inss.date = formatDate(this.postingParameters.postingData.inss.date, mod);
        }

      },

      postingConfig: () => {
        const companyId = localStorage.getItem('idEmpresa');

        this.postingParameters.officePostingData = data || {};
        this.postingParameters.postingData = {
          payroll: {},
          fgts: {},
          inss: {},
          general: {},
        }
        this.postingParameters.postingItems = {
          payroll: {},
          fgts: {},
          inss: {},
          general: {},
        }

        this.postingParameters.postingForms = {
          payroll: FolhaESocialUtil.createPostingFormGroup(),
          fgts: FolhaESocialUtil.createPostingFormGroup(),
          inss: FolhaESocialUtil.createPostingFormGroup(),
          general: new FormGroup({
            property: new FormControl(null),
          }),
        };

        if (!this.postingParameters.officePostingData[companyId]) {
          this.postingParameters.officePostingData[companyId] = {};
        }
        if (this.selectedMember) {
          if (!this.postingParameters.officePostingData[companyId][this.selectedMember.cpf]) {
            this.postingParameters.officePostingData[companyId][this.selectedMember.cpf] = null;
          } else {
            this.postingParameters.postingData = this.postingParameters.officePostingData[companyId][this.selectedMember.cpf];
            this.existingPostingDataToForm();
            this.postingParameters.edit = false;
          }
        }
      }
    };

    if (dataMapping[type]) {
      dataMapping[type]();
    }

  }

  existingPostingDataToForm() {
    const setBankAccount = (postingData: any, form: any) => {
      if (postingData && postingData.bankAccountId != null) {
        const bankAccount = this.bankAccounts.find(p => p.id === postingData.bankAccountId);
        if (bankAccount) {
          form.get('bankAccount').setValue(bankAccount.id);
        }
      }
    };

    const setPlanAccount = (postingData: any, form: any) => {
      if (postingData && postingData.planAccountId != null) {
        const planAccount = this.planAccounts.find(p => p.id === postingData.planAccountId);
        if (planAccount) {
          form.get('planAccount').setValue(planAccount);
        }
      }
    };

    const setReleaseType = (postingData: any, form: any) => {
      if (postingData && postingData.releaseType != null) {
        form.get('releaseType').setValue(postingData.releaseType);
      }
    };

    const setHistoric = (postingData: any, form: any) => {
      if (postingData && postingData.historicId) {
        const historic = this.historics.find(h => h.id === postingData.historicId);
        if (historic) {
          form.get('historic').setValue(historic.id);
        }
      }
    };

    const setProperty = (postingData: any, form: any) => {
      if (postingData && postingData.propertyCode) {
        const property = this.properties.find(p => p.propertyCode === postingData.propertyCode);
        if (property) {
          form.get('property').setValue(property);
        }
      }
    };

    const setGroupers = (postingData: any, form: any) => {
      this.postingParameters.postingData.general.selectedGroupers = [];
      if (postingData && postingData.groupersIds) {
        this.postingParameters.postingData.general.selectedGroupers = this.groupers.filter(p => postingData.groupersIds.includes(p.id));
      }
    };

    const setDate = (postingData: any, form) => {
      if (postingData) {
        if (postingData.date != null)
          form.get('date').setValue(postingData.date);
        form.get('nextMonth').setValue(
          postingData.nextMonth != null ? postingData.nextMonth : true
        );
      }
    };


    const params = this.postingParameters;
    setBankAccount(params.postingData.payroll, params.postingForms.payroll);
    setBankAccount(params.postingData.fgts, params.postingForms.fgts);
    setBankAccount(params.postingData.inss, params.postingForms.inss);

    setPlanAccount(params.postingData.payroll, params.postingForms.payroll);
    setPlanAccount(params.postingData.fgts, params.postingForms.fgts);
    setPlanAccount(params.postingData.inss, params.postingForms.inss);

    setReleaseType(params.postingData.payroll, params.postingForms.payroll);
    setReleaseType(params.postingData.fgts, params.postingForms.fgts);
    setReleaseType(params.postingData.inss, params.postingForms.inss);

    setHistoric(params.postingData.payroll, params.postingForms.payroll);
    setHistoric(params.postingData.fgts, params.postingForms.fgts);
    setHistoric(params.postingData.inss, params.postingForms.inss);

    setProperty(params.postingData.general, params.postingForms.general);

    setGroupers(params.postingData.general, params.postingForms.general);

    setDate(params.postingData.payroll, params.postingForms.payroll);
    setDate(params.postingData.fgts, params.postingForms.fgts);
    setDate(params.postingData.inss, params.postingForms.inss);

  }


  initializeSearch(type: 'bankAccounts' | 'planAccounts' | 'historics' | 'properties' | 'groupers') {
    for (let i = 0; i < 3; i++) {
      switch (type) {
        case 'bankAccounts':
          this.filter_bankAccount[i].next(this.bankAccounts.slice());
          this.bankAccountFilterCtrl[i].valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => this.applyFilter('bankAccounts', i));
          break;
        case 'planAccounts':
          this.filter_planAccount[i].next(this.planAccounts.slice());
          this.planAccountFilterCtrl[i].valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => this.applyFilter('planAccounts', i));
          break;
        case 'historics':
          this.filter_historic[i].next(this.historics.slice());
          this.historicFilterCtrl[i].valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => this.applyFilter('historics', i));
          break;
        case 'properties':
          this.filter_property.next(this.properties.slice());
          this.propertyFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => this.applyFilter('properties', i));
          break;
        case 'groupers':
          this.filter_grouper.next(this.groupers.slice());
          this.grouperFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => this.applyFilter('groupers', i));
      }
    }
  }

  applyFilter(type: 'bankAccounts' | 'planAccounts' | 'historics' | 'properties' | 'groupers', i: number) {
    let search: string;

    switch (type) {
      case 'bankAccounts':
        if (!this.bankAccounts) return;
        search = this.bankAccountFilterCtrl[i].value ? this.bankAccountFilterCtrl[i].value.toLowerCase() : '';
        const bankAccountsFiltered = !search ? this.bankAccounts.slice() :
          this.bankAccounts.filter(bank =>
            (bank.code.toString() + " - " + bank.description.toLowerCase()).includes(search)
          );
        this.filter_bankAccount[i].next(bankAccountsFiltered);
        break;

      case 'planAccounts':
        if (!this.planAccounts) return;
        search = this.planAccountFilterCtrl[i].value ? this.planAccountFilterCtrl[i].value.toLowerCase() : '';
        const planAccountsFiltered = !search ? this.planAccounts.slice() :
          this.planAccounts.filter(plan =>
            plan.description.toLowerCase().includes(search)
          );
        this.filter_planAccount[i].next(planAccountsFiltered);
        break;

      case 'historics':
        if (!this.historics) return;
        search = this.historicFilterCtrl[i].value ? this.historicFilterCtrl[i].value.toLowerCase() : '';
        const historicsFiltered = !search ? this.historics.slice() :
          this.historics.filter(hist =>
            hist.description.toLowerCase().includes(search)
          );
        this.filter_historic[i].next(historicsFiltered);
        break;

      case 'properties':
        if (!this.properties) return;
        search = this.propertyFilterCtrl.value ? this.propertyFilterCtrl.value.toLowerCase() : '';
        const propertiesFiltered = !search ? this.properties.slice() :
          this.properties.filter(property =>
            (property.propertyCode.toString() + " - " + property.name.toLowerCase()).includes(search)
          );
        this.filter_property.next(propertiesFiltered);
        break;

      case 'groupers':
        if (!this.groupers) return;
        search = this.grouperFilterCtrl.value ? this.grouperFilterCtrl.value.toLowerCase() : '';
        const groupersFiltered = !search ? this.groupers.slice() :
          this.groupers.filter(grouper =>
            grouper.name.toLowerCase().includes(search)
          );
        this.filter_grouper.next(groupersFiltered);
        break;
    }
  }

  hasHistoric(i) {
    if (this.historicFilterCtrl[i].value == null) {
      return true;
    }
    return 'HISTÓRICO PADRÃO FARMCONT'.toLowerCase().includes(this.historicFilterCtrl[i].value.toLowerCase());
  }

  setDescriptionHistoric(id: any): string {
    let h: HistoricDTOResponse;
    if (id === 'DEFAULT') {
      h = {
        id: 69,
        description: 'HISTÓRICO PADRÃO FARMCONT',
        code: 'DEFAULT',
        model: ' LANÇAMENTO #@PARTICIPANTE@# DF-e #@NUMERO-DOCUMENTO@#.'
      };
    } else {
      h = this.historics.find(h => h.id === id);
    }
    return `<b>${h.description}:</b> ${h.model.replace(/#@/g, '<span class="text-success">@').replace(/@#/g, '@</span>')}`;
  }

  selectedGrouper(grouper): void {
    const exist = this.postingParameters.postingData.general.selectedGroupers.some(g => g.id === grouper.id);

    if (exist) {
      this.snackBar.open('Agrupador já selecionado!', 'atencao');
    } else {
      this.postingParameters.postingData.general.selectedGroupers.push(grouper);
      this.grouperInput.nativeElement.blur();
    }
  }

  openModal(type: string, obj?: any,) {
    const modalOptions: NgbModalOptions = {
      backdrop: 'static',
      windowClass: localStorage.getItem('theme') === 'dark' ? 'dark-theme' : ''
    };

    const components = {
      bankAccount: CadastroContaBancariaComponent,
      planAccount: CadastroPlanoDeContasComponent,
      historic: CadastroHistoricoComponent,
      property: CadastroImovelComponent,
      grouper: CadastroAgrupadoresComponent,
    }


    const modalRef = this.modalService.open(components[type], modalOptions);

    if (obj) {
      if (type === 'bankAccount') {
        modalRef.componentInstance.contaExistente = obj;
      } else if (type === 'planAccount') {
        obj.name = obj.description.split(' - ')[1];
        modalRef.componentInstance.node = obj;
        modalRef.componentInstance.editar = true;
        modalRef.componentInstance.root = false;
        modalRef.componentInstance.customIds = [obj.customId];
        modalRef.componentInstance.descriptions = [obj.description.split(' -')[1]];
      } else if (type === 'historic') {
        modalRef.componentInstance.existingHistoric = obj;
      } else if (type === 'property') {
        modalRef.componentInstance.imovelExistente = obj;
      }
    }

    modalRef.result.then((result) => {
      if (result) {
        const fetchType = {
          bankAccount: 'bankAccounts',
          planAccount: 'planAccounts',
          historic: 'historics',
          property: 'properties',
          grouper: 'groupers'
        }[type];
        if (fetchType) {
          this.fetchAllData(fetchType);
        }
      }
    }, () => {
    });
  }

  selectPlanAccount(form) {
    form.get('releaseType').setValue(ReleaseTypeString[form.get('planAccount').value.releaseType]);
    form.get('historic').setValue(form.get('planAccount').value.historicId ? form.get('planAccount').value.historicId : '');
  }

  submitPostingData() {
    const forms = this.postingParameters.postingForms;
    const officePostingData = this.postingParameters.officePostingData;
    const companyId = localStorage.getItem('idEmpresa');
    const memberCpf = this.selectedMember.cpf;

    const getValue = (formName: string, controlName: string, subKey?: string) => {
      const form = forms[formName];
      const control = form && form.get(controlName);
      const value = control ? control.value : null;
      return subKey && value ? value[subKey] : value;
    };

    const buildSection = (formName: string) => ({
      bankAccountId: getValue(formName, 'bankAccount'),
      planAccountId: getValue(formName, 'planAccount', 'id'),
      releaseType: getValue(formName, 'releaseType'),
      historicId: getValue(formName, 'historic'),
      date: getValue(formName, 'date'),
      nextMonth: getValue(formName, 'nextMonth')
    });

    const postingData = {
      payroll: buildSection('payroll'),
      fgts: buildSection('fgts'),
      inss: buildSection('inss'),
      general: {
        propertyCode: getValue('general', 'property', 'propertyCode'),
        groupersIds: this.postingParameters.postingData.general.selectedGroupers ? this.postingParameters.postingData.general.selectedGroupers.map(g => g.id) : null,
      }
    };

    this.loading = true;
    officePostingData[companyId] = officePostingData[companyId] || {};
    officePostingData[companyId][memberCpf] = postingData;

    this.userProvider.postEsPostingConfig(officePostingData)
      .then(async () => {
        this.postingParameters.postingItems = {
          payroll: {},
          fgts: {},
          inss: {},
          general: {},
        }
        this.fetchAllData();
      })
      .catch(() => {
        this.loading = false;
        this.snackBar.open('Erro ao salvar dados', 'error');
      });
  }

  canPostPayrollType(type) {
    const postingData = this.postingParameters.postingData[type];
    const generalPostingData = this.postingParameters.postingData.general;
    const payrollData = this.data.grids[type] && this.data.grids[type].processData[0].length;
    return postingData && postingData.bankAccountId && postingData.planAccountId && postingData.releaseType && postingData.historicId && postingData.date && generalPostingData.propertyCode && payrollData;
  }

  async createPosting(type, singleClick) {

    const itemsForBookkeeping = await this.setDataToBookkeepingObj(type);
    if (!itemsForBookkeeping) return;

    if (singleClick) {
      this.loading = true;
      this.postingProvider.createEsPosting(itemsForBookkeeping)
        .then(() => {
          this.snackBar.openLong('Lançamento criado com sucesso', 'success');
          this.getPayrollData();
        })
        .catch((error) => {
          this.snackBar.open(`${error.error.error_description}`, 'erro');
        }).finally(() => {
        this.loading = false;
      });
    } else {
      const modalOptions: NgbModalOptions = {
        backdrop: 'static',
        windowClass: localStorage.getItem('theme') === 'dark' ? 'dark-theme' : '',
      };
      const modalRef = this.modalService.open(CadastrarLancamentoComponent, modalOptions);
      modalRef.componentInstance.folhaEsocial = itemsForBookkeeping;
    }
  }

  async setDataToBookkeepingObj(key) {
    try {
      const {
        bankAccountId = null,
        historicId = null,
        planAccountId = null,
        releaseType = null,
        date = null,
        nextMonth = null
      } = this.postingParameters.postingData[key] || {};
      const monthOffset = nextMonth != null ? (nextMonth ? 1 : 0) : 1;
      return {
        docs: [{
          companyId: localStorage.getItem('idEmpresa'),
          participantId: this.selectedMember.participantId,
          ...(this.postingParameters.postingData.general.propertyCode && {propertyCode: this.postingParameters.postingData.general.propertyCode}),
          docType: "PAYROLL",
          postings: [
            {
              companyId: localStorage.getItem('idEmpresa'),
              amountPaid: this.data.indicators[key],
              payrollIds: this.data.grids[key].processData[0].reduce((acc, item) => acc.concat(item.ids), []),
              grouperIds: this.postingParameters.postingData.general.selectedGroupers.map(g => g.id),
              ...(bankAccountId && {bankAccountId}),
              ...(historicId && {
                historic: JSON.stringify({
                  historico: "",
                  modelo: this.historics.find((historic) => historic.id == historicId).model
                })
              }),
              ...(planAccountId && {accountsChartId: planAccountId}),
              ...(releaseType && {postingReleaseType: ReleaseType[releaseType]}),
              ...(date && {
                paymentDate: moment(new Date(
                  this.consultDateUtil.year,
                  this.consultDateUtil.getMonth(this.consultDateUtil.month) - 1 + monthOffset,
                  date
                )).format('YYYY-MM-DD'),
              }),
            },
          ],
          receiptFileIds: [],
        }],
      };
    } catch (error) {
      console.error('Error in setDataToBookkeepingObj:', error);
      this.snackBar.open('Erro ao criar lançamento', 'error');
      return null;
    }

  }

  async editPosting(type: string): Promise<void> {

    const postingId = this.data.existingPostingByField[type];
    const docId = await this.postingProvider.getDocIdByPostingId(postingId)
    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      windowClass: localStorage.getItem('theme') == 'dark' ? 'dark-theme' : ''
    };
    const modalRef = this.modalService.open(CadastrarLancamentoComponent, modalOptions);
    modalRef.componentInstance.lancamentoExistenteID = docId;
    modalRef.result.then((result) => {
      if (result) {
        this.getPayrollData();
      }
    });
  }

  runEsPayrollSearch() {
    this.loading = true;
    const obj = {
      month: this.consultDateUtil.getMonth(this.consultDateUtil.month).toString().padStart(2, '0'),
      year: this.consultDateUtil.year.toString(),
      cpfCnpj: this.selectedMember.cpf,
    }
    this.payrollProvider.runEsPayrollSearch(obj).then(result => {
      this.snackBar.open('Busca em execução...', 'success');
    }).catch((error) => {
      this.snackBar.open(`${error.error.error_description}`, 'erro');
    }).finally(() => {
      this.loading = false;
    });
  }

  protected readonly
  Object = Object;

  firePayrollSearchSwal(type: string) {

    if (this.data.existingPostingByField.payroll || this.data.existingPostingByField.fgts || this.data.existingPostingByField.inss) {
      this.firePayrollExistingPostingSwal();
      return;
    }

    const period = `<b>${this.consultDateUtil.mesesExtensos[+this.consultDateUtil.getMonth(this.consultDateUtil.month) - 1]}</b> de <b>${this.consultDateUtil.year}</b>`;
    const producerInfo = `<b>${this.selectedMember.name} - ${this.selectedMember.cpfFormatted}</b>`;

    let message = type === 'manual-search'
      ? `Esta ação utilizará o <b>certificado digital</b> do produtor para acessar seu eSocial, <b>notificando-o</b> via e-mail desse acesso. <br><br>A busca será realizada para período de ${period} para ${producerInfo}`
      : `Esta ação <b>${type.includes('disable') ? 'desabilitará' : 'habilitará'}</b> a busca automática de dados de folha de pagamento.<br><br>Dessa forma os dados de folha serão trazidos de forma <b>${type.includes('disable') ? 'manual' : 'automática'}, ${type.includes('disable') ? 'necessitando' : 'sem necessidade'}</b> de interação do usuário`;

    message += '<br><br><b>Deseja continuar?</b>';

    Swal.fire({
      title: 'Atenção',
      html: message,
      icon: 'warning',
      reverseButtons: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Sim, desejo continuar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#f05050'
    }).then((result) => {
      if (result.isConfirmed) {
        const options = {
          'manual-search': () => this.runEsPayrollSearch(),
          'automatic-search-single-disable': () => this.saveAutomaticSearchOption(false, false),
          'automatic-search-all-disable': () => this.saveAutomaticSearchOption(true, false),
          'automatic-search-single-enable': () => this.saveAutomaticSearchOption(false, true),
          'automatic-search-all-enable': () => this.saveAutomaticSearchOption(true, true),
        };
        if (options[type]) {
          options[type]();
        }
      }
    });
  }

  firePayrollExistingPostingSwal() {
    Swal.fire({
      title: 'Atenção',
      html: `<b>Já existe um lançamento neste mês</b>
        <br><br>Você deve remover o lançamento existente para solicitar uma nova busca`,
      icon: 'warning',
      reverseButtons: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK!',
      showCancelButton: false,
    }).then((result) => {
    });
  }
}
